<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main">
        <SubTitleComponent :title="title"></SubTitleComponent>
        <div class="box">
          <el-row :gutter="20" class="row">
            <el-col :span="14">
              <div class="img">
                <img v-if="media_type == 0" :src="src" alt="">
                <video v-if="media_type == 1" :src="src" alt="" controls></video>
              </div>
            </el-col>
            <el-col :span="10">
              <!-- <el-descriptions title="参数" :column="1" border>
                <el-descriptions-item label="创作时间">{{ date }}</el-descriptions-item>
                <el-descriptions-item label="空间类型">{{ space_type }}</el-descriptions-item>
                <el-descriptions-item label="创作风格">{{ style_type }}</el-descriptions-item>
                <el-descriptions-item label="AI大模型">{{ ai_model }}</el-descriptions-item>
                <el-descriptions-item label="风格强度">{{ style_intensity }}</el-descriptions-item>
                <el-descriptions-item label="描述强度">{{ describing }}</el-descriptions-item>
              </el-descriptions> -->
              <div class="list">
                <div class="item title">参数</div>
                <div class="item">
                  <div class="label">创作时间</div>
                  <div class="content">{{ date }}</div>
                </div>
                <div class="item">
                  <div class="label">空间类型</div>
                  <div class="content">{{ space_type }}</div>
                </div>
                <div class="item">
                  <div class="label">创作风格</div>
                  <div class="content">{{ style_type }}</div>
                </div>
                <div class="item">
                  <div class="label">AI大模型</div>
                  <div class="content">{{ model_name }}</div>
                </div>
                <div class="item">
                  <div class="label">风格强度</div>
                  <div class="content">{{ style_intensity }}</div>
                </div>
                <div class="item">
                  <div class="label">描述强度</div>
                  <div class="content">{{ describing }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="tool">
            <el-col :span="6"><el-button type="primary" icon="el-icon-picture-outline" plain @click="toPath('/effectsave')">生成新的效果图</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-picture" plain @click="toPath('/effectvideo')">图生视频</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-first-aid-kit" plain @click="toPath('/effectaiedit')">AI改图</el-button></el-col>
            <el-col :span="6"><el-button type="primary" icon="el-icon-download" plain @click="toDownload">下载</el-button></el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
let _ajaxType = 0

const imgDemo = require('../../assets/pic_xgt.jpg')
import { apiDownload } from '@/utils/download';

export default {
  name: 'EffectDetail',
  components: {},
  data() {
    return {
      title: '',
      src: '',
      media_type: 0,
      date: '',
      space_type: '',
      style_type: '',
      model_name: '',
      style_intensity: '',
      describing: '',
    }
  },
  created() {
    _ajaxType = 0
    console.log(this.$route.params.id); // 打印出 URL 中的 id 参数
    let _id = this.$route.params.id
    this.id = _id
    this.getData()
  },
  mounted() {
    
  },
  methods: {
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData(){
      let _id = this.id
      let _url = "/api/?mod=effect&action=detail"
      let _effectData = {
        effect_id: _id
      }
      // console.log(this.axios)
      this.axios.post(_url, _effectData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("effectData", _data);
        if (json.data.errcode == 0) {
          // this.customerData = _data
          this.title = _data.client_name
          this.src = _data.effect_result[0].file_url
          this.date = _data.createtime
          this.space_type = _data.space_type
          this.style_type = _data.style_type
          this.model_name = _data.model_name
          this.media_type = _data.effect_result[0].file_type
          this.style_intensity = _data.style_percent
          this.describing = _data.description_percent
          // this.title = _data.client_name
        }
        console.log(json.data);
      })
    },
    toDownload(){
      const link = document.createElement('a')
      let _type = this.media_type // 替换为你的图片 URL
      // link.download = 'sample.jpg' // 指定下载的文件名
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)let _href = ''
      if(_type == 0){
        let _img = this.src
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = this.src
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      apiDownload(
        _href
      )
    },
    toPath(path) {
      this.$router.push({ path: path })
    },
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}

.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;

  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .row {
      display: flex;
      // flex-direction: column;
    }
    .img {
      font-size: 0;
      img {
        width: 100%;
        border-radius: 10px;
      }
      video {
        width: 100%;
      }
    }
    .list {
      display: grid;
      grid-template-rows: 50px;       /* 首行高度80px */
      // grid-auto-rows: minmax(60px, 1fr);
      // grid-auto-rows: minmax(calc(100%/7), 1fr);
      gap: 10px;
      height: 100%;
      padding: 20px;
      align-items: center;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 10px;
      .item {
        height: 100%;
        border-bottom: 1px solid #eee;
        .label {
          display: flex;
          width: 30%;
          height: 100%;
          float: left;
          font-size: 18px;
          align-items: center;
          span {
            display: inline-block;
          }
        }
        .content {
          display: flex;
          width: 70%;
          height: 100%;
          float: right;
          font-size: 18px;
          justify-items: right;
          align-items: center;
        }
        &.title {
          font-size: 24px;
          font-weight: 700;
        }
        &:last-child {
          border: 0;
        }
      }
    }
    .tool {
      margin-top: 40px;
      .el-button {
        width: 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Effect/Detail.vue